<template>
  <div class="body kuang" v-if="list">
    <div class="btn_y_cnt">
      <div :class="['btn_y', statusColor]">
        {{ statusTxt }}
      </div>
      <div class="btn_y">
        <button round type="info" @click="toDetail(formId, id)" class="btn_y">
          修改
        </button>
        <!-- <span class="btn_l">|</span>
        <button round type="info" @click="handlerDel(formId, id)" class="btn_y btn_d">
          删除
        </button> -->
      </div>
    </div>
    <van-cell v-if="obj.school" title="学校" :value="obj.school" />

    <van-cell
      v-if="obj.train"
      title="本年度是否参加过培训"
      :value="format(obj.train, 1)"
    />
    <template v-if="obj.train == 1">
      <template v-for="(item, index) in obj.items" :key="index">
        <van-cell-group>
          <van-cell v-if="item.trainName" title="培训名称" :value="item.trainName" />
          <van-cell
            v-if="item.trainLevel"
            title="培训级别"
            :value="format(item.trainLevel, 15)"
          />
          <van-cell
            v-if="item.organizer"
            title="主办单位"
            :value="format(item.organizer, 16)"
          />
          <van-cell v-if="item.classHours" title="学时" :value="item.classHours" />
          <van-cell
            v-if="item.trainDate"
            title="培训日期"
            :value="format(item.trainDate, 6)"
          />
        </van-cell-group>
      </template>
    </template>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { format } from "@/common/js/utils";
import { dataStataus } from "@/common/js";
import { useRouter } from "vue-router";
export default {
  props: {
    list: Array,
    formId: Number,
    id: String,
    status: Number,
    handlerDel: Function,
  },
  setup(props) {
    const router = useRouter();

    const state = reactive({
      obj: {},
      statusTxt: "",
      statusColor: "",
    });
    onMounted(() => {
      const { list, status } = props;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          state.obj[list[i].fieldCode] = list[i].value;
        }
      }
      const sr = dataStataus.filter((res) => res.status == status);
      if (sr.length > 0) {
        state.statusTxt = sr[0].name;
        state.statusColor = sr[0].class;
      }
    });
    const toDetail = (formId, id) => {
      const url = `/info/add/form${parseInt(formId) - 1}`;
      router.push({ path: url, query: { id, type: 1 } });
    };

    // watch(props, (newProps) => {
    //   console.log('props.list', newProps.list)
    //   if (newProps.list.length > 0) {
    //     for (let i = 0; i < newProps.list.length; i++){
    //       state.obj[props.list[i].fieldCode] = newProps.list[i].value
    //     }
    //   }
    // });

    return {
      ...toRefs(state),
      format,
      toDetail,
    };
  },
};
</script>
<style lang="less" scoped>
@import "@/common/style/mixin";
.body {
  border: 1px solid #e5e7eb;
  margin: 10px;
}
.btn_y_cnt {
  display: flex;
  justify-content: space-between;
}
.btn_y {
  color: #fe8784;
  padding: 0.2rem 0.3rem;
  background: #fff;
}
.btn_d {
  color: green;
}
.btn_l {
  color: #969799;
}
</style>
